import aiTools from './aiTools';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
    items: [aiTools]
};

export default menuItems;
